import Configuration from './configuration';

export default Configuration;